var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.carbonPrefix}--aspect-ratio`, `${_vm.carbonPrefix}--aspect-ratio--${_vm.ratio}`]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }